<form (ngSubmit)="confirm()" #invoiceForm="ngForm" class="p-4">
  <h5 class="mb-3">{{ 'CONFIRM_THE_ACTION' | translate }}</h5>

  <div class="form-check mb-2">
    <p-checkbox
      binary="true"
      [(ngModel)]="allSelected"
      [label]="'ACTIONS.ALL' | translate"
      inputId="check-all"
      name="check-all"
    ></p-checkbox>
  </div>

  <!-- Har bir variant -->
  <div *ngFor="let opt of types" class="form-check mb-2">
    <p-checkbox
      binary="false"
      [value]="opt.id"
      [(ngModel)]="selectedOptions"
      [label]="opt.label | translate"
      [inputId]="'opt-' + opt.id"
      name="options"
    ></p-checkbox>
  </div>

  <div class="d-flex justify-content-end gap-2 buttons mt-3">
    <button type="submit" [disabled]="isDisabled()" class="btn btn-primary">{{ 'CONFIRM' | translate }}</button>
    <button type="button" class="btn btn-secondary" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
  </div>
</form>
